import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { CareerDao } from '@app/dao/career/career.dao';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { combineLatest, map, take } from 'rxjs';
import { Parameters, PledgeRead } from '../../definition/interface/Pledge';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
  selector: 'profession-form',
  templateUrl: './profession-form.component.html',
  styleUrls: ['./profession-form.component.scss'],
  standalone: false,
})
export class ProfessionFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  references: any;
  pledge: PledgeRead;
  showSwisslifeActivitySectorLcbFt = false;
  groupes: any[][];
  categories: any[][];
  situations: any[] = [];
  swisslifeActivitySectors: any[] = [];
  inseeActivitySectors: any[] = [];
  companyActivitySectors = [];
  organizationId: number;
  reference$;

  note = false;
  noteIndex = 0;

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private careerDao: CareerDao,
    private referenceDao: ReferenceDao,
    private attributionDao: AttributionDao,
    private subscriptionFacade: SubscriptionFacadeService,
    private httpClient: HttpClient,
  ) {
    super(formConstructor);
    // new add
  }

  ngOnInit() {
    const { parameters = {} as Parameters } =
      this.subscriptionFacade.getPledge();
    this.showSwisslifeActivitySectorLcbFt =
      this.swisslifeActivitySectorLcbFtRequired(parameters);
    this.reference$ = combineLatest([
      this.userDao.getCouple(),
      this.careerDao.getReferences(),
      this.referenceDao.getCompanyActivitySectors(),
      this.referenceDao.getSwisslifeActivitySectors(),
      this.referenceDao.getInseeActivitySectors(),
    ]).pipe(
      map(
        ([
          users,
          references,
          companyActivitySectors,
          swisslifeActivitySectors,
          inseeActivitySectors,
        ]) => {
          this.references = references;
          this.groupes = [references.groupes, references.groupes];
          this.categories = [references.categories, references.categories];
          this.situations = references.situations;
          this.companyActivitySectors = [...companyActivitySectors];
          this.swisslifeActivitySectors = [...swisslifeActivitySectors];
          this.inseeActivitySectors = [...inseeActivitySectors];

          return references;
        },
      ),
    );

    this.attributionDao
      .getOrganization()
      .pipe(take(1))
      .subscribe((data: any) => {
        this.organizationId = data.id;
        this.subscriptionFacade.initForm(this, {
          organizationId: this.organizationId,
          pledgeParameters: parameters,
        });
      });

    if (this.showSwisslifeActivitySectorLcbFt) {
      this.owners.controls.forEach(owner => {
        owner
          .get('swisslifeActivitySectorLcbFt')
          .valueChanges.subscribe(value => {
            if (value === 'AUTRE') {
              owner
                .get('swisslifeActivitySectorLcbFtOther')
                .setValidators([Validators.required]);
              owner
                .get('swisslifeActivitySectorLcbFtOther')
                .updateValueAndValidity();
            } else {
              owner
                .get('swisslifeActivitySectorLcbFtOther')
                .setValidators([Validators.nullValidator]);
              owner
                .get('swisslifeActivitySectorLcbFtOther')
                .updateValueAndValidity();
            }
          });
      });
    }
  }

  showingWorkInPublic(form, index) {
    const professionSituation = this.owners
      ?.get(`${index}`)
      .get('professionSituation');
    return (
      professionSituation !== null &&
      professionSituation.value !== null &&
      professionSituation.value === 'SALARIED'
    );
  }
  updateGroupe(event, index) {
    this.categories[index] =
      event === 'INDEPENDENT_9'
        ? [...this.references.categories]
        : this.references.categories.filter(c => c.groupe === event);

    this.owners?.get(`${index}`).get('professionCategory').clearValidators();
    this.owners
      ?.get(`${index}`)
      .get('professionCategory')
      .setValidators([Validators.required]);
    this.owners
      ?.get(`${index}`)
      .get('professionCategory')
      .updateValueAndValidity();
  }
  updateSituation(event, index) {
    this.groupes[index] = this.references.groupes.filter(
      c => c.situation === event,
    );
    if (event && event !== 'SALARIED') {
      this.owners
        ?.get(`${index}`)
        .get('professionWorkInPublic')
        .setValue(false);
    }
  }

  updateCategorie(event, index) {
    if (event && ['CADRE_PUBLIC', 'PROFESSEUR_INSTITUTEUR'].includes(event)) {
      this.owners?.get(`${index}`).get('professionWorkInPublic').setValue(true);
    }

    //this.owners?.get(`${index}`).get("professionGroup").setValue(groupe);
  }
  onLabelChange(labelValue: string, index: number) {
    this.noteIndex = index;
    const policeWord = [
      'GENDARME',
      'OFFICIER',
      'FLIC',
      'POLICIER',
      'POLICE',
      'FLICARD',
      'LIMIER',
      'MILITAIRE',
      'LIEUTENANT',
      'armée',
    ];
    const policeWordArray = policeWord.map(word => word.toLowerCase());
    const labelArray = labelValue.toLowerCase().split(' ');
    for (const word of labelArray) {
      if (policeWordArray.includes(word)) {
        this.note = true;
      } else {
        this.note = false;
      }
    }
  }
  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
